import { render } from "./ForgotPasswordInput.vue?vue&type=template&id=5476be9a"
import script from "./ForgotPasswordInput.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/sbimh.nl/tickets.sbimh.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__